var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M4.00583 13.3333C4.00392 13.3333 4.0031 13.3309 4.0046 13.3298L14.7721 4.95502C15.4943 4.39329 16.5057 4.39329 17.2279 4.95502L27.9954 13.3298C27.9969 13.3309 27.9961 13.3333 27.9942 13.3333H25.3333V24.6667C25.3333 25.7712 24.4379 26.6667 23.3333 26.6667H8.66666C7.5621 26.6667 6.66667 25.7712 6.66667 24.6667V13.3333H4.00583Z",
    stroke: "#C0BAC1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlank);
export default __webpack_public_path__ + "static/media/home-blank.46bc4d1f745b4bf377f12c532210c9af.svg";
export { ForwardRef as ReactComponent };